import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar: React.FC = () => {
  const { isAuthenticated, role, login, logout, user } = useAuth();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <NavLink to="/" className="navbar-brand">
          <img src="/mini-logo.png" alt="Patriot Academy" className="brand-icon" />
          <span className="brand-text">Patriot Academy</span>
          <span className="brand-premium">Premium</span>
        </NavLink>

        <div className="navbar-links">
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            Home
          </NavLink>

          <NavLink
            to="/courses"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
          >
            Courses
          </NavLink>

          {isAuthenticated && (
            <NavLink
              to="/dashboard"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Dashboard
            </NavLink>
          )}

          {isAuthenticated && role === 'admin' && (
            <NavLink
              to="/admin"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Admin
            </NavLink>
          )}

          {isAuthenticated && (role === 'instructor' || (role === 'admin' && user?.instructorId)) && (
            <NavLink
              to="/instructor"
              className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            >
              Instructor
            </NavLink>
          )}
        </div>

        <div className="navbar-auth">
          {isAuthenticated ? (
            <div className="navbar-user">
              <span className="navbar-username">{user?.name}</span>
              <button className="btn btn-outline" onClick={logout}>
                Sign Out
              </button>
            </div>
          ) : (
            <div className="navbar-auth-buttons">
              <button className="btn btn-outline" onClick={login}>
                Sign In
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
